module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('va-small-box', {
    staticClass: "info-box box-green",
    attrs: {
      "icon": "ion-bag ",
      "title": _vm.message[1].totalDisbursment,
      "description": "Total Disbursement Amount",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToTotalDisbursment
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('va-small-box', {
    staticClass: "info-box box-red",
    attrs: {
      "icon": "ion-bag ",
      "title": _vm.message[2].totalOutstanding,
      "description": "Total Outstanding Amount",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToTotalOutstanding
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16ace00b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/totaloutstanding.vue
// module id = 728
// module chunks = 0